const value = 'ООО «Антифишинг»';

export default value;
